// @flow

import React from 'react';
import moment from 'moment';
import get from 'lodash/get';

import { getFullName } from 'clark-utils';
import { Col } from 'clark-styles';

import type { ClientsType } from 'types/clients';
import type { SessionType } from 'types/sessions';
import type { EngagementsType } from 'types/engagements';
import type { SubjectsType } from 'types/subjects';

import { CenteredCol, Offset, SmallHide, SmallOnly, TableRow } from 'styles/table';
import UnstyledLink from 'styles/unstyled-link';

import { hasSessionReport } from 'utils/helpers/sessions';
import { ClientName, Details, StyledAdd, StyledArrow, StyledButton, StyledCheck } from './styles';

type PropsType = {
  clients: ClientsType,
  earnings: string,
  session: SessionType,
  sessionId: string,
  tutoringEngagements: EngagementsType,
  subjects: SubjectsType,
};

const handleClick = sessionId => {
  window.location = `/sessions/${sessionId}`;
};

const reportButtonSm = session => (hasSessionReport(session) ? <StyledCheck /> : <StyledAdd />);

const reportButtonLg = (session, sessionId) =>
  hasSessionReport(session) ? (
    <StyledCheck />
  ) : (
    <StyledButton layout="secondary" styleType="outline" onClick={() => handleClick(sessionId)}>
      Add report
    </StyledButton>
  );

const SessionRow = ({
  clients,
  earnings,
  session,
  sessionId,
  tutoringEngagements,
  subjects,
}: PropsType) => {
  const {
    id,
    attributes: { endTime, startTime, tutoringEngagementId },
    relationships: {
      client: { data: clientData },
    },
  } = session;

  const client = clients[get(clientData, 'id')];
  const clientFullName = client ? getFullName(client.attributes) : 'Unknown Student';

  const engagement = tutoringEngagements[tutoringEngagementId];
  const subject = subjects[get(engagement, 'relationships.subject.data.id')];
  const subjectName = subject ? subject.attributes.name : 'Unknown Subject';

  const formattedSessionDate = moment(startTime).format('ddd, MMM DD');
  const formattedSessionStartTime = moment(startTime).format('h:mm');
  const formattedSessionEndTime = moment(endTime).format('h:mm a');
  const sessionTimeString = `${formattedSessionDate} ${formattedSessionStartTime} - ${formattedSessionEndTime}`;

  return (
    <UnstyledLink to={`/sessions/${id}`}>
      <SmallOnly>
        <TableRow alignItems="center">
          <Col sm={7} md={3} lg={3}>
            <Details>
              <ClientName>{clientFullName}</ClientName>
              <div>{sessionTimeString}</div>
            </Details>
          </Col>
          <CenteredCol sm={3} md={2} lg={2}>
            {reportButtonSm(session)}
          </CenteredCol>
          <Col sm={1} md={1} lg={1}>
            <StyledArrow />
          </Col>
        </TableRow>
      </SmallOnly>
      <SmallHide>
        <TableRow alignItems="center">
          <Col sm={3} md={3} lg={3}>
            <Offset>{sessionTimeString}</Offset>
          </Col>
          <Col sm={2} md={2} lg={2}>
            {clientFullName}
          </Col>
          <Col sm={2} md={2} lg={2}>
            {subjectName}
          </Col>
          <Col sm={2} md={2} lg={2}>
            {earnings}
          </Col>
          <CenteredCol sm={2} md={2} lg={2}>
            {reportButtonLg(session, sessionId)}
          </CenteredCol>
          <Col sm={1} md={1} lg={1}>
            <StyledArrow />
          </Col>
        </TableRow>
      </SmallHide>
    </UnstyledLink>
  );
};

export default SessionRow;



// WEBPACK FOOTER //
// ./src/components/sessions/list/past/row/index.js